import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment, UrlTree } from '@angular/router';
import { Platform } from '@ionic/angular/standalone';
import { AutoLoginPartialRoutesGuard, OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { WITH_POPUP } from '../auth.provider';
import { OAuthService } from '../service/oauth/oauth.service';

export function oauthCanMatchWithConfig(configId: string): CanMatchFn {
  return (route: Route, segments: UrlSegment[]) => oauthCanMatch(route, segments, configId);
}

export async function oauthCanMatch(
  _route: Route,
  segments: UrlSegment[],
  configId?: string,
): Promise<boolean | UrlTree> {
  const isWithPopup = inject(WITH_POPUP, { optional: true });
  const autoLoginPartialRoutesGuardClass = inject(AutoLoginPartialRoutesGuard);
  const authService = inject(OAuthService);
  const oidcSecurityService = inject(OidcSecurityService);
  const platform = inject(Platform);

  let authenticated = false;
  try {
    const response = await firstValueFrom(oidcSecurityService.checkAuthIncludingServer());
    authenticated = response.isAuthenticated;
  } catch (error) {
    authenticated = false;
  }

  if (!authenticated && platform.is('capacitor') && isWithPopup) {
    return await authService
      .authorizeWithPopUp()
      .then((response) => response?.isAuthenticated ?? false);
  }
  return firstValueFrom(autoLoginPartialRoutesGuardClass.canLoad(), { defaultValue: false });
}
